import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { dxUiNotify } from '@/utils/dx-helper';

export function getAiDataSource({
                                  validationFn,
                                  dataFn,
                                  paramsFn,
                                  key = 'id',
                                  onLoadedFn,
                                  onLoadingFn,
                                  onBeforeLoad,
                                  remoteOperation,
                                  customFilterFn,
                                  insertFn,
                                  updateFn,
                                  removeFn,
                                  defaultDescSort = true,
                                  dateFields = [],
                                  columns = [],
                                  baseSort = []
                                }) {

  const dateColumns = [...getDateColumns(columns), ...dateFields];

  return new DataSource({
    paginate: false,
    store: new CustomStore({
      key,
      load: async (loadOptions) => {
        const res = {
          key,
          data: [],
          totalCount: 0,
        };
        let isGropedByDate = false;

        if (validationFn && !validationFn()) {
          return new Promise(resolve => {
            resolve(res);
          });
        }

        if (onBeforeLoad) {
          onBeforeLoad();
        }

        if (customFilterFn) {
          const customFilter = customFilterFn();
          if (customFilter && customFilter.length) {
            const { filter } = loadOptions;
            loadOptions.filter = filter && [customFilter, 'and', filter] || customFilter;
          }
        }

        if (!loadOptions.sort) {
          loadOptions.sort = [{ 'selector': key, 'desc': defaultDescSort }];
        }

        if (baseSort?.length) {
          loadOptions.sort.unshift(...baseSort);
        }

        const args = {
          ...(paramsFn && paramsFn() || {}),
          ...(remoteOperation && loadOptions || {})
        }

        isGropedByDate = loadOptions.group && dateColumns.length && dateColumns.includes(loadOptions.group[0].selector);

        return dataFn(args).then(data => {
          if (checkErrorResponse(data)) {
            throw data;
          }
          const items = remoteOperation && data.data || data || [];
          return {
            ...res,
            data: isGropedByDate ? getGroupedDate(items) : items ,
            totalCount: Array.isArray(data) && data.length || data.totalCount || Array.isArray(data.data) && data.data.length || 0,
            summary: data.summary
          };
        }).catch(e => {
            throw new Error(errorHandler(e));
        });
      },
      insert: insertFn,
      update: updateFn,
      remove: removeFn,
      onLoading: onLoadingFn,
      onLoaded: onLoadedFn,
      byKey: (key) => {
        return dataFn({ ...paramsFn(), key });
      },
    }),
  });
}

export const onLoadedData = ({ saveButton, dxInstance, undoEditData}) => {
  if (saveButton?.clicked) {
    undoEditData(dxInstance);
    saveButton.clicked = false;
  }
};

export const expandTree = ({ data, dxInstance, ids, expand = true }) => {
  (data || ids).map(x => dxInstance[expand && 'expandRow' || 'collapseRow']((ids && x) || x[dxInstance.option('keyExpr')]));
};

export const errorHandler = (e, errorContainer) => {
  const error = (
    (e.errors?.length && e.errors?.map(msg => msg?.message || msg)) ||
    (e.validationErrors?.length && e.validationErrors?.map(msg => msg?.message || msg)) ||
    (e.validation_errors?.length && e.validation_errors?.map(msg => msg?.message || msg)) ||
    [e.error || e.message || e.err_message || e.mes || e?.msg?.message || e.err || 'Ошибка загрузки данных. Подробности в консоле.']).join('; ');
  dxUiNotify(error, 'error', error.length * 25);
  console.log(e);
  if (errorContainer) {
    errorContainer.innerHTML = error;
  }
  return error;
}
  export const checkErrorResponse = (data) => {
  if (data.error || data.uuid || data.validationErrors?.length || data.validation_errors || data.err || data.err_uuid || data.err_code || data.errors?.length)
    throw data;
}

export const createFilterArray = (filterArray, operation = 'and') => {
  return filterArray.reduce((total, item) => {
    if (item) {
      if (total.length)
        total.push(operation);
      total.push(item);
    }
    return total;
  }, []);
}

const getGroupedDate = (items) => {
  const newItems = [];
  let lastValues;
  for (const i of items) {
    if (!i.key) {
      continue;
    }

    const _date = new Date(i.key);
    const values = [_date.getFullYear(), _date.getMonth() + 1, _date.getDate()];
    if (i.key.length > 10) {
      values.push(_date.getHours());
      values.push(_date.getMinutes());
    }

    if (!lastValues || lastValues[0] !== values[0]) {
      newItems.push(createItems({}, 0, values));
    } else {
      let _item = newItems[newItems.length - 1];
      for (let i = 1; i < values.length; i++) {
        if (values[i] !== lastValues[i]) {
          _item.items.push(createItems({}, i, values));
          break;
        }
        _item = _item.items[_item.items.length - 1];
      }
    }
    lastValues = values;
  }
  return newItems;
}

const createItems = (item, index, values) =>
{
  item = { key: values[index], count: 1 };
  if (values.length - 1 !== index) {
    if (!item.items) item.items = [];
    item.items = item.items.concat([createItems(item, index + 1, values)]);
  }
  return item;
}

const getDateColumns = (columns) => {
  const fields = columns.filter(c => c.dataType.includes('date')).map(c => c.dataField);
  columns.filter(c => c.columns).forEach(c => {
    fields.push(...getDateColumns(c));
  });
  return fields;
}

export const addNewRowData = ({ dxInstance, sourceData, fields }) => {

  const changes = dxInstance.option('editing.changes');

  const data = fields.reduce((total, item) => {
    total[item] = sourceData[item]
    return total;
  }, {});

  changes.push({
    data,
    key: null,
    type: 'insert'
  });

  dxInstance.option('editing.changes', changes);
}
